/**
 * Формирует ключ выбранной услуги по её id и сегментам.
 * Используется для индексации продуктов/выбранных услуг в Map.
 * Формат ключа `${serviceId}/${segmentIds.join('/')}`
 */
export function buildSelectedServiceKey(serviceId: string, segmentIds: string[]): string {
	return `${serviceId}/${segmentIds.join('/')}`;
}
